export default "__VITE_ASSET__DdI7JNlX__"